export default __webpack_public_path__ + "static/media/snake.707d5c7b.png";